import { z } from 'zod';

/**
 * Finish-to-Start dependency between two work stages in the same project.
 * The service layer rejects self-loops and multi-hop cycles; this schema
 * only validates the wire payload.
 */
export const stageDependencyKindSchema = z.enum(['fs']);
export type StageDependencyKind = z.infer<typeof stageDependencyKindSchema>;

export const stageDependencySchema = z.object({
  id: z.string(),
  projectId: z.string(),
  predecessorId: z.string(),
  successorId: z.string(),
  kind: stageDependencyKindSchema,
  createdAt: z.string(),
});
export type StageDependency = z.infer<typeof stageDependencySchema>;

export const createStageDependencyRequestSchema = z
  .object({
    predecessorId: z.string().min(1),
    successorId: z.string().min(1),
    kind: stageDependencyKindSchema.default('fs'),
  })
  .refine((v) => v.predecessorId !== v.successorId, {
    message: 'A stage cannot depend on itself',
    path: ['successorId'],
  });
export type CreateStageDependencyRequest = z.infer<
  typeof createStageDependencyRequestSchema
>;
